
/**
 * Row布局
 * wzhe
 */
var SgiColEO = function () {
    return ({
        ctlH: "100%",
        ctlN: "列",
        span: 8,
        desId: "EP_EO_UI_5102",
        style: {}
    })
};
export { SgiColEO };
export default SgiColEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiColEO.js